import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import VariantBuilderPanelCollapse from "../variants/VariantBuilderPanelCollapse";

const VariantSettingsThemeScheduler = (props) => {
  const [contextData] = useContext(VariantContextData);
  let variant = contextData.objects.variant;

  return (
    <React.Fragment>
      <VariantBuilderPanelCollapse name="Scheduler" open={false}>
        <VariantBuilderSetting
          object={variant}
          setting_name="[options][scheduler-max-width]"
          setting_type="range"
          object_type="variants"
          label="Max Width"
          value={variant.options["scheduler-max-width"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][scheduler-max-width-mobile]"
          setting_type="range"
          object_type="variants"
          label="Max Width"
          value={variant.options["scheduler-max-width-mobile"]}
          placeholder="auto"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][scheduler-min-height]"
          setting_type="range"
          object_type="variants"
          label="Min Height"
          value={variant.options["scheduler-min-height"]}
          placeholder="700"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          setting_name="[options][scheduler-min-height-mobile]"
          setting_type="range"
          object_type="variants"
          label="Min Height"
          value={variant.options["scheduler-min-height-mobile"]}
          placeholder="700"
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Border Style"
          setting_name="[options][scheduler-border-style]"
          setting_type="border_style"
          value={variant.options["scheduler-border-style"]}
          placeholder="none"
          show_reset={true}
        />

        {variant.options["scheduler-border-style"] &&
          variant.options["scheduler-border-style"] !== "none" && (
            <div
              className="col-xs-12 some-vertical-space setting"
              style={{ marginBottom: "5px" }}
            >
              <div className="row">
                <div className="col-xs-12">
                  <div className="mb-[5px] text-xl text-black dark:text-white">
                    Border Width
                  </div>

                  {["left", "top", "bottom", "right"].map((side) => {
                    const settingName = `[options][scheduler-border-width-${side}]`;
                    return (
                      <VariantBuilderSetting
                        key={settingName}
                        object={variant}
                        object_type="variants"
                        setting_name={settingName}
                        setting_type="number"
                        value={
                          variant.options[`scheduler-border-width-${side}`]
                        }
                        placeholder={
                          variant.options["scheduler-border-width"] || "1"
                        }
                        col="3"
                        note={window.capitalizeFirstLetter(side)}
                        classNames="spacing-inputs"
                        min={0}
                        allow_empty={true}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Border Color"
          setting_name="[options][scheduler-border-color]"
          setting_type="color_v2"
          placeholder="#000"
          value={
            variant.options["scheduler-border-color"]
              ? variant.options["scheduler-border-color"]
              : undefined
          }
          show_reset={true}
          condition={
            variant.options["scheduler-border-style"] &&
            variant.options["scheduler-border-style"] !== "none"
          }
        />

        <VariantBuilderSetting
          object={variant}
          object_type="variants"
          label="Border Radius"
          setting_name="[options][scheduler-border-radius]"
          setting_type="range"
          value={variant.options["scheduler-border-radius"]}
          placeholder="0"
          min={0}
          max={100}
          range_step="1"
          allow_empty={true}
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>
    </React.Fragment>
  );
};

export default VariantSettingsThemeScheduler;
